import { createSlice } from "@reduxjs/toolkit";
import {
  viewHouse,
  singleHouse,
  registerHouse,
  updateHouse,
  deleteHouse,
  singleUserHouse,
  approveHouse,
  approvedHouseList,
} from "../actions/houseAction";

const HouseSlice = createSlice({
  name: "houses",
  initialState: {
    houses: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateHouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.houses = action.payload;
      })
      .addCase(updateHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteHouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.houses = action.payload;
      })
      .addCase(deleteHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleHouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.houses = action.payload;
      })
      .addCase(singleHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerHouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.houses = action.payload;
      })
      .addCase(registerHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleUserHouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleUserHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.houses = action.payload;
      })
      .addCase(singleUserHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveHouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.houses = action.payload;
      })
      .addCase(approveHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewHouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewHouse.fulfilled, (state, action) => {
        state.loading = false;
        state.houses = action.payload;
      })
      .addCase(viewHouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(approvedHouseList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approvedHouseList.fulfilled, (state, action) => {
        state.loading = false;
        state.houses = action.payload;
      })
      .addCase(approvedHouseList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default HouseSlice.reducer;
